module.exports = __webpack_public_path__ + "assets/images/USD025.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/USD025.png
// module id = 1449
// module chunks = 1